import React, { useState } from 'react'

import { splitStyleProps } from '../../utils/splitStyleProps'
import { BackgroundImage, BackgroundImageProps } from '../BackgroundImage'
import { Skeleton } from '../Skeleton'

export interface ProgressiveImageProps extends BackgroundImageProps {}

export const ProgressiveImage = ({ src, ...restProps }: ProgressiveImageProps) => {
  const [isLoading, setLoading] = useState(true)

  const handleLoad = () => {
    setLoading(false)
  }

  const handleError = () => {
    setLoading(false)
  }

  const [styleProps] = splitStyleProps(restProps)

  return (
    <Skeleton isLoaded={!isLoading} {...styleProps}>
      <BackgroundImage src={src} position="relative" {...restProps} />
      <img src={src} onLoad={handleLoad} onError={handleError} style={{ display: 'none' }} />
    </Skeleton>
  )
}

export default ProgressiveImage
